/**
 * Represents an image observer that lazy loads images for better page performance.
 */
class ImageObserver {
  /**
   * Lazy load images that have opted in.
   */
  static lazyLoad() {
    const imgs = document.querySelectorAll('img[data-lazy-load]');
    
    if (imgs.length > 0) {
      const imageObserver = new IntersectionObserver((entries) => {
        for (let index = 0; index < entries.length; ++index) {
          const entry = entries[index];
          
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            imageObserver.unobserve(img);
          }
        }
      });

      for (let index = 0; index < imgs.length; ++index) {
        const img = imgs[index];
        imageObserver.observe(img);
      }
    }
  }
}

// Lock object to prevent modification (true static).
Object.freeze(ImageObserver);

export default ImageObserver;
